"use client"

import type React from "react"

import { useState } from "react"

export interface DragData {
  type:
    | "work-order"
    | "segment"
    | "segment-part"
    | "scheduled-item"
    | "scheduled-item-reschedule";
  id: string
  hours: number
  workOrderId?: string
  segmentId?: string // For segments
  scheduledItemId?: string // For scheduled items being moved (local id: scheduled-{n})
  /** When dragging multiple past-due tasks from a segment card */
  scheduledItemIds?: string[]
  /** True when rescheduling past-due item(s) from work-order search */
  isPastDueReschedule?: boolean
  sourceTechnicianId?: number // For scheduled items: the technician it's being moved from
  sourceDay?: string // For scheduled items: the day it's being moved from
  segmentName?: string // Segment displayText/name for API calls
  description?: string // Segment description for API calls
  // For work-order type: contains all segments to be scheduled
  segments?: {
    id: string
    name: string
    estimatedHours: number
  }[]
  // Additional work order info for display
  workOrderNumber?: string
  invoiceNumber?: string
  customerName?: string
  customerNumber?: string
  woStatusId?: number
  locationId?: number // Work order location for validation
  // Additional work order details for technician card display
  unitModel?: string
  unitNumber?: string
  vinNumber?: string
  myReference?: string
  woDescription?: string
  woPriorityId?: number
}

export function useDragDrop() {
  const [draggedData, setDraggedData] = useState<DragData | null>(null)

  const handleDragStart = (e: React.DragEvent, data: DragData) => {
    setDraggedData(data)
    e.dataTransfer!.effectAllowed = "move"
    const dataStr = JSON.stringify(data)
    e.dataTransfer!.setData("text/plain", dataStr)
    e.dataTransfer!.setData("application/json", dataStr)
  }

  const handleDragEnd = () => {
    setDraggedData(null)
  }

  const getDraggedData = (e: React.DragEvent): DragData | null => {
    try {
      let data = e.dataTransfer!.getData("application/json")
      if (!data) {
        data = e.dataTransfer!.getData("text/plain")
      }
      return data ? JSON.parse(data) : null
    } catch (error) {
      console.error(" Failed to parse drag data:", error)
      return null
    }
  }

  return {
    draggedData,
    handleDragStart,
    handleDragEnd,
    getDraggedData,
  }
}
